export type SocialNetwork = 'instagram' | 'facebook' | 'website';

/**
 * A short label for a social URL, derived from the URL itself — there is no
 * separate handle field to keep in sync.
 *
 *   instagram.com/eventik        -> @eventik
 *   facebook.com/eventik         -> eventik
 *   https://www.eventik.cz/x     -> eventik.cz
 *
 * null when nothing sensible comes out, so the caller shows the icon alone.
 */
export function deriveSocialLabel(network: SocialNetwork, url: string | undefined): string | null {
  if (!url) return null;

  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }
  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;

  if (network === 'website') {
    const host = parsed.hostname.replace(/^www\./i, '');
    return host || null;
  }

  // First path segment is the handle on both networks. Trailing slashes,
  // /p/<postid> style deep links and query strings are all ignored.
  const segment = parsed.pathname.split('/').filter(Boolean)[0];
  if (!segment) return null;
  // A profile handle, not a section of the site.
  if (!/^[A-Za-z0-9._-]{1,40}$/.test(segment)) return null;

  return network === 'instagram' ? `@${segment}` : segment;
}
